export const SECTION_SPACING = { base: 10, md: 12, lg: 14, xl: 16 };
export const FEATURED_PROPERTIES_NUMBER = 5;
export const LATEST_PROPERTIES_NUMBER = 5;
